var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, SimpleChanges, OnChanges, Renderer2, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HasSubscriptions } from '../../has-subscriptions';
import { environment } from "../../../../environments/environment-wrapper";
var PaginationComponent = /** @class */ (function (_super) {
    __extends(PaginationComponent, _super);
    function PaginationComponent(_renderer, _activatedRoute, document) {
        var _this = _super.call(this) || this;
        _this._renderer = _renderer;
        _this._activatedRoute = _activatedRoute;
        _this.document = document;
        _this.showTextPages = true;
        _this.disableSEO = false;
        _this.onChangePage = new EventEmitter();
        return _this;
    }
    PaginationComponent.prototype.ngOnInit = function () {
        var _this = this;
        // We use the snapshot url to get the URL for SEO purposes
        // We subsribe to the route in case they stay on a same route but change a sub folder portion of the route
        this.addSub(this._activatedRoute.url.subscribe(function (url) {
            _this.baseUrl = environment.cdnServerUrl.slice(0, -1) + '/' + url.join('/');
        }));
    };
    PaginationComponent.prototype.ngOnChanges = function (changes) {
        if (!this.disableSEO && (changes.currentPageNumber || changes.totalPages)) {
            // Update the Link tags in the head to point to the correct pages
            this.updateLinkTags();
        }
    };
    PaginationComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        // We need to remove the Link tags
        this.removeLinkTags();
    };
    PaginationComponent.prototype.changePage = function (newPage, $event) {
        $event.preventDefault();
        $event.target.blur();
        this.onChangePage.emit(newPage);
    };
    /**
     * Adds/Updates the link tags in the head element to point to the correct next/prev pages for pagination purposes
     */
    PaginationComponent.prototype.updateLinkTags = function () {
        if (this.totalPages > 1) {
            // We only add the next page if there is more than 1 page, and not on the last page
            if (this.currentPageNumber < this.totalPages - 1) {
                // Check if the link already exists
                var linkTagNext = PaginationComponent.nextLinkRef ? PaginationComponent.nextLinkRef : this._renderer.createElement('link');
                this._renderer.setAttribute(linkTagNext, 'rel', 'next');
                this._renderer.setAttribute(linkTagNext, 'href', this.baseUrl + '?page=' + (this.currentPageNumber + 2));
                if (!PaginationComponent.nextLinkRef) {
                    PaginationComponent.nextLinkRef = linkTagNext;
                    this._renderer.appendChild(this.document.head, linkTagNext);
                }
            }
            else if (PaginationComponent.nextLinkRef)
                this.removeNextTag();
            // We only add the prev page if there is more than 1 page, and not on the first page
            if (this.currentPageNumber > 0) {
                // Check if the link already exists
                var linkTagPrev = PaginationComponent.prevLinkRef ? PaginationComponent.prevLinkRef : this._renderer.createElement('link');
                this._renderer.setAttribute(linkTagPrev, 'rel', 'prev');
                this._renderer.setAttribute(linkTagPrev, 'href', this.baseUrl + '?page=' + (this.currentPageNumber));
                if (!PaginationComponent.prevLinkRef) {
                    PaginationComponent.prevLinkRef = linkTagPrev;
                    this._renderer.appendChild(this.document.head, linkTagPrev);
                }
            }
            else if (PaginationComponent.prevLinkRef)
                this.removePrevTag();
        }
        else {
            this.removeLinkTags();
        }
    };
    /**
     * make sure to remove the link tags so that on pages without pagination they are not present
     */
    PaginationComponent.prototype.removeLinkTags = function () {
        if (PaginationComponent.prevLinkRef)
            this.removePrevTag();
        if (PaginationComponent.nextLinkRef)
            this.removeNextTag();
    };
    PaginationComponent.prototype.removeNextTag = function () {
        this._renderer.removeChild(this.document.head, PaginationComponent.nextLinkRef);
        PaginationComponent.nextLinkRef = null;
    };
    PaginationComponent.prototype.removePrevTag = function () {
        this._renderer.removeChild(this.document.head, PaginationComponent.prevLinkRef);
        PaginationComponent.prevLinkRef = null;
    };
    return PaginationComponent;
}(HasSubscriptions));
export { PaginationComponent };
